import { ErrorResponse } from '@src/interface/api/response.interface'
import {
	deleteVendorProduct,
	DeleteVendorProductResponse,
} from '@src/lib/api/product/deleteVendorProduct'
import type { CreateProductType } from '@src/type/product/form'
import { useMutation, UseMutationResult } from '@tanstack/react-query'
import { AxiosError } from 'axios'

const useDeleteVendorProductQuery = (): UseMutationResult<
	DeleteVendorProductResponse,
	AxiosError<ErrorResponse>,
	string
> => {
	return useMutation((productNo) => {
		return deleteVendorProduct(productNo)
	})
}
export default useDeleteVendorProductQuery
